module.exports = __webpack_public_path__ + "img/06展前快訊.85c6972a.jpg";